import React, { useEffect, useState } from 'react';
import { EffectFade, Navigation, Autoplay } from 'swiper';
import PageBanner from '../../CommonPages/PageBanner';
import { Swiper, SwiperSlide } from "swiper/react";
import ProjectDetailsSlider from '../ProjectDetailsSlider';
import MyLoader from '../../Shared/MyLoader';
import SectionGridLines from '../../CommonPages/SectionGridLines';
import { Outlet } from 'react-router-dom';

const WesthillApartment = () => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Simulate an API call
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        setTimeout(() => {
            setIsLoading(false);
        }, 1500);
    }, []);

    if (isLoading) {
        // return <Loader/>;
        return <MyLoader />
    }
    return (
        <div>

            <main className="wrapper">
                <SectionGridLines />
                <Outlet />
                <PageBanner pageTitle='Projects' subpath='/projects' title="Westhill Apartment" activePage="Westhill Apartment" />
                <section className="project-details bg-dark-200">
                    <div className="container">
                        <div className="gallery_slider">
                            <div className="swiper swiper_gallery">
                                <Swiper
                                    modules={[EffectFade, Navigation, Autoplay]}
                                    effect="slide"
                                    slidesPerView={1}
                                    autoplay={{
                                        delay: 2500,
                                        disableOnInteraction: false,
                                    }}
                                    loop={true}
                                    navigation={{
                                        prevEl: '.swiper-button-prev',
                                        nextEl: '.swiper-button-next',
                                    }}
                                >
                                    <SwiperSlide>
                                        <ProjectDetailsSlider img='images/portfolio/details/Apartment/Westhill/westhill1.webp' />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <ProjectDetailsSlider img='images/portfolio/details/Apartment/Westhill/westhill2.webp' />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <ProjectDetailsSlider img='images/portfolio/details/Apartment/Westhill/westhill3.webp' />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <ProjectDetailsSlider img='images/portfolio/details/Apartment/Westhill/westhill4.webp' />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <ProjectDetailsSlider img='images/portfolio/details/Apartment/Westhill/westhill5.webp' />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <ProjectDetailsSlider img='images/portfolio/details/Apartment/Westhill/westhill6.webp' />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <ProjectDetailsSlider img='images/portfolio/details/Apartment/Westhill/westhill7.webp' />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <ProjectDetailsSlider img='images/portfolio/details/Apartment/Westhill/westhill8.webp' />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <ProjectDetailsSlider img='images/portfolio/details/Apartment/Westhill/westhill9.webp' />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <ProjectDetailsSlider img='images/portfolio/details/Apartment/Westhill/westhill10.webp' />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <ProjectDetailsSlider img='images/portfolio/details/Apartment/Westhill/westhill11.webp' />
                                    </SwiperSlide>
                                    
                                </Swiper>

                                {/* <!-- Add Buttons --> */}
                                <div className="swiper-navigation">
                                    <div className="swiper-button-prev"><i className="bi bi-arrow-left"></i></div>
                                    <div className="swiper-button-next"><i className="bi bi-arrow-right"></i></div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-4 col-md-4">
                                <div className="sidebar">
                                    <div className="project-information">
                                        <h6 className="widget-title">
                                            Project Information
                                            <span className="title-line"></span>
                                        </h6>
                                        <ul>
                                            <li>
                                                <span className="data">Client:</span> <span className="value">Ashvinbhai Adroja</span>
                                            </li>
                                            <li>
                                                <span className="data"> Area:</span> <span className="value">5200 Sqft</span>
                                            </li>
                                            <li>
                                                <span className="data">Location:</span> <span className="value">Rajkot, Gujarat</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-8 col-md-8">
                                <div className="project-details_inner">
                                    <div className="post_content">
                                        <div className="post-header">
                                            <h3 className="post-title">Westhill Apartment</h3>
                                        </div>
                                        <div className="fulltext">
                                            <p>
                                                Westhill is a grand 5,200 sq. ft. urban sanctuary in Rajkot, meticulously designed for a discerning client who welcomed bold and distinctive aesthetics. Guided by the core philosophy that “every corner carries its own impact,” the design journey unfolded with a balance of comfort, drama, and harmony across the entire home. Within this refined apartment, the bedroom interior reflects calmness, simplicity, and timeless design. It is a space where understated elegance takes shape through soft tones and deliberate detailing — crafting an atmosphere of serene escape. A warm beige palette anchors the room, allowing textures and lighting to become expressive features. Vertical fluted paneling behind the TV unit draws the eye upward, introducing depth and rhythm. A hidden door seamlessly blends into the composition — a quiet testament to the studio’s pursuit of integrated, refined design. Recessed lighting and cove-lit ceilings gently sculpt the space, while natural daylight softly diffuses through sheer drapery — achieving a delicate interplay between openness and intimacy. Furniture selections follow a soft modernist language — low in form, warm in tone, and minimal in profile. A curved accent chair by the window, paired with a slender table and botanical decor, creates a contemplative nook that feels both graceful and grounded. The design ethos of Westhill lies in restraint and refinement. Eschewing excess, the space draws its power from proportion, texture, and light — resulting in an environment that soothes, restores, and elevates everyday living. Each decision reflects a commitment to creating spaces that are not just seen, but felt — extending the home’s guiding belief that every corner deserves to make an impact.
                                            </p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

        </div>
    )
}

export default WesthillApartment
